export const generateNameCSVFile = (label, from, to) => {
    const fromDate = new Date(from)
    const toDate = to ? new Date(to) : new Date()

    const dates = {
        from: `${fromDate.toLocaleDateString('en-US')} ${fromDate.toLocaleTimeString('en-US')}`,
        to: `${toDate.toLocaleDateString('en-US')} ${toDate.toLocaleTimeString('en-US')}`,
    }
    return `${label} (${dates.from} - ${dates.to})_${Date.now()}.csv`
}

export const prettifyNumber = (num = 0) => {
    const n = num.toString()
    const separator = ' '
    return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + separator)
}
